<template>
  <div class="playvideo-container">
    <div class="content-wrapper">
      <!-- 左侧课程列表 -->
      <div class="left-panel">
        <div class="course-info">
          <h2 class="course-title">{{ courseInfo.courseName }}</h2>
          <p class="course-meta">
            <span>适合年级：{{ courseInfo.fitGrade }}</span>
            <span>课程数量：{{ courseInfo.courseNum }}节</span>
          </p>
        </div>

        <div class="section-list">
          <div
            v-for="section in sortedSections"
            :key="section.courseVideoId"
            class="section-item"
            :class="{ active: currentSection.section === section.section }"
            @click="selectSection(section)"
          >
            <div class="section-number">第{{ section.section }}节</div>
            <div class="section-title">{{ section.videoTitle }}</div>
            <div class="section-status" :class="{ completed: section.videoStatus === 1 }">
              {{ section.videoStatus === 1 ? '已制作课程' : '未制作课程' }}
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧视频播放区域 -->
      <div class="right-panel">
        <!-- 视频播放器 -->
        <div class="video-player" v-if="currentSection">
          <div class="player-wrapper">
            <div id="J_prismPlayer"></div>
          </div>
          <div class="video-info">
            <h3 class="video-title">{{ currentSection.videoTitle }}</h3>
            <div class="teacher-info">
              <img alt="" :src="currentSection.teacherAvatar" class="teacher-avatar" />
              <span class="teacher-name">讲师：{{ currentSection.teacherName }}</span>
            </div>
            <div class="video-meta">
              <span>创建时间：{{ currentSection.createTime }}</span>
            </div>
          </div>
        </div>

        <!-- 课程详情 -->
        <div class="course-detail" v-if="courseInfo">
          <h3>课程详情</h3>
          <div class="detail-content">
            <div class="detail-item">
              <label>课程名称：</label>
              <span>{{ courseInfo.courseName }}</span>
            </div>
            <div class="detail-item">
              <label>课程分类：</label>
              <span>{{ courseInfo.cateName }}</span>
            </div>
            <div class="detail-item">
              <label>适合年级：</label>
              <span>{{ courseInfo.fitGrade }}</span>
            </div>
            <div class="detail-item">
              <label>教学形式：</label>
              <span>{{ formatTeachingFormat(courseInfo.teachingFormat) }}</span>
            </div>
            <div class="detail-item">
              <label>学生姓名：</label>
              <span>{{ courseInfo.studentName }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/common/api'
import Aliplayer from 'aliyun-aliplayer';
import 'aliyun-aliplayer/build/skins/default/aliplayer-min.css';
export default {
  name: 'PlayVideo',
  mounted() {
    this.initPage()
    // 启动定时器，每10秒执行一次学习进度收集
    this.progressTimer = setInterval(() => {
      if (this.player && this.currentSection.courseVideoId) {
        this.learnProgressCollect()
      }
    }, 10000)
  },
  data() {
    return {
      planId:null,
      courseInfo: {},
      sections: [],
      currentSection: {
        courseVideoId:null
      },
      playauth: "",
      player: null,
      progressTimer: null
    };
  },
  computed: {
    sortedSections() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.sections.sort((a, b) => a.section - b.section)
    }
  },
  methods: {
    async initPage() {
      const query = this.$route.query
      const planId = query.id
      const status = query.status
      const section = query.section
      if(status !== "success"){
        this.$message.error('请求异常,请联系管理员')
        return
      }
      if (!planId || !section) {
        this.$message.error('缺少参数,请联系管理员')
        return
      }
      this.planId=planId
      try {
        const response = await api.lean_section({ id: planId });
        if (response.data.code === "200") {
          this.courseInfo = response.data.data
          this.sections = response.data.data.sections || []
          //设置当前播放的章节
          if (section && this.sections.length > 0) {
            const targetSection = this.sections.find(s => String(s.section) === section)
            if (targetSection) {
              this.currentSection = targetSection;
              await this.beginLearn()
            }
          } else if (this.sections.length > 0) {
            // 默认播放第一个章节
            this.currentSection = this.sections[0]
            await this.beginLearn()
          }
        } else {
          this.$message.error(response.data.msg || '获取课程信息失败')
        }
      } catch (error) {
        console.error('获取课程信息失败:', error)
        this.$message.error('获取课程信息失败，请稍后重试')
      }
    },
    async beginLearn(){
      try {
        const res = await api.learn_begin(
            {
              courseVideoId: this.currentSection.courseVideoId,
              section: this.currentSection.section,
              planId: this.planId
            }
        );
        if (res.data.code === "200") {
          await this.getVideoPlayAuth()
        } else {
          this.$message.error(res.msg || '获取视频播放权限失败')
        }
      }catch (error){
        console.error('开始学习失败:', error)
        this.$message.error('开始学习失败')
      }
    },
    async getVideoPlayAuth() {
      if (!this.currentSection.courseVideoId) {
        this.$message.error('视频ID不能为空')
        return;
      }
      const self=this;
      try {
        const res = await api.play_video_auth(
            {
              id: this.currentSection.courseVideoId
            }
        );
        if (res.data.code === "200") {
          this.playauth=res.data.data;
          await self.initPlayVideo();
        } else {
          this.$message.error(res.msg || '获取视频播放权限失败')
        }
      } catch (error) {
        console.error('获取视频播放权限失败:', error)
        this.$message.error('获取视频播放权限失败')
      }
    },
    async initPlayVideo(){
      const player = new Aliplayer({
        id: 'J_prismPlayer',
        width: "100%",
        height: "500px",
        vid: this.currentSection.videoId,
        playauth: this.playauth,
        license: {
          domain: "xctxa.com",
          key: "fPxuOybLtT10om4Ttc81f30c511a448f682444462a39842d7"
        },
        skinLayoutIgnore: [
          'controlBar.downloadButton' // 隐藏控制栏上的下载按钮
        ]
      },()=>{
        console.log("播放器初始化成功");
        this.player=player;
      });
    },
    formatTeachingFormat(format) {
      const formatMap = {
        'recorded': '录播',
        'live': '直播',
        'mixed': '混合'
      }
      return formatMap[format] || format
    },
    async selectSection(section) {
      this.currentSection = section
      const query = { ...this.$route.query, section: section.section }
      await this.$router.replace({ query })
      window.location.reload()
    },
    async learnProgressCollect(){
      try {
        let process=Math.round((this.player.getCurrentTime()/this.player.getDuration())*100)
        const res = await api.learn_progress_collect(
            {
              section: this.currentSection.section,
              planId: this.planId,
              progress: process
            }
        );
        if (res.data.code === "200") {
          console.log("进度上报成功");
        } else {
          console.log("进度上报失败");
        }
        if(process>=100){
          // 组件销毁前清除定时器
          if (this.progressTimer) {
            clearInterval(this.progressTimer)
            this.progressTimer = null
          }
        }
      }catch (error){
        console.error('开始学习失败:', error)
        this.$message.error('开始学习失败')
      }
    },
  },
  watch: {
    '$route.query': {
      handler() {
        this.initPage()
      },
      deep: true
    }
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.progressTimer) {
      clearInterval(this.progressTimer)
      this.progressTimer = null
    }
  }
};
</script>

<style scoped>
.playvideo-container {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
}

.content-wrapper {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  gap: 20px;
}

.left-panel {
  width: 300px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.course-info {
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.course-title {
  margin: 0 0 10px 0;
  font-size: 18px;
  color: #333;
}

.course-meta {
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 14px;
  color: #666;
}

.section-list {
  max-height: 600px;
  overflow-y: auto;
}

.section-item {
  padding: 15px 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.3s;
}

.section-item:hover {
  background-color: #f8f9fa;
}

.section-item.active {
  background-color: #e6f7ff;
  border-left: 3px solid #1890ff;
}

.section-number {
  font-weight: bold;
  color: #1890ff;
  margin-bottom: 5px;
}

.section-title {
  font-size: 14px;
  color: #333;
  margin-bottom: 5px;
  line-height: 1.4;
}

.section-status {
  font-size: 12px;
  color: #999;
}

.section-status.completed {
  color: #52c41a;
}

.right-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.video-player {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.player-wrapper {
  position: relative;
  background: #000;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-video i {
  font-size: 48px;
  margin-bottom: 10px;
}

.video-info {
  padding: 20px;
}

.video-title {
  margin: 0 0 15px 0;
  font-size: 20px;
  color: #333;
}

.teacher-info {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.teacher-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 10px;
}

.teacher-name {
  color: #666;
}

.video-meta {
  color: #999;
  font-size: 14px;
}

.course-detail {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.course-detail h3 {
  margin: 0 0 15px 0;
  font-size: 16px;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.detail-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-item {
  display: flex;
}

.detail-item label {
  width: 80px;
  color: #666;
  font-weight: bold;
}

.detail-item span {
  flex: 1;
  color: #333;
}

@media (max-width: 768px) {
  .content-wrapper {
    flex-direction: column;
  }

  .left-panel {
    width: 100%;
  }

  .player-wrapper {
    min-height: 300px;
  }
}
</style>
